import { throttle } from "./throttle";

export function enableActivityTracking(csrfToken) {
  // Start tracking activity only when the LV page requests it.
  // `once: true` ensures we only subscribe (and set up the inner handlers) a single
  // time per window, even though the server may push the event on every LV mount.
  window.addEventListener("phx:mailroom:report-activity", () => {
    // We set a relatively high throttle of 10 seconds to avoid spamming the server.
    // Users are only logged out after 1 hour of inactivity, so 10 seconds is more than enough.
    const reportThrottle = 10000;
    const reportActivity = throttle(() => { trackActivityInSession(csrfToken); }, reportThrottle)

    reportActivity();

    document.onmousedown = reportActivity;
    document.onkeydown = reportActivity;
    document.addEventListener('scroll', reportActivity, true);
  }, { once: true });
}

async function trackActivityInSession(csrfToken) {
  fetch("/report-activity", {
    method: "GET",
    redirect: "error",
    headers: { "X-CSRF-Token": csrfToken },
  }).catch(err => {
    // A failed report means we want to reload the page to make the user follow the redirect to /sign-in
    window.location.reload();
  });
}
